import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import { ProvedorSessao } from './sessao.js';
import { ApiError } from './api/cliente.js';
import './estilos/tokens.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      retry: (tentativa, erro) => {
        // 401 e 403 não melhoram com repetição — o cliente já tentou o refresh.
        if (erro instanceof ApiError && (erro.expirou || erro.semPermissao)) return false;
        return tentativa < 2;
      },
    },
  },
});

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProvedorSessao>
        <App />
      </ProvedorSessao>
    </QueryClientProvider>
  </StrictMode>,
);
